import styled from "styled-components";

export const HeaderWrapper = styled.div`
  justify-content: space-between;
  align-items: center;
  gap: 20px;
  padding: 12px 32px;
  background: linear-gradient(135deg, #1A2F3A 0%, #0F2128 100%);
  color: #fff;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.2);
  border-bottom: 1px solid rgba(123, 196, 224, 0.2);

  .left {
    align-items: center;
    gap: 18px;
    margin-left: 0;

    .badgeIcon {
      cursor: pointer;
      display: none;

      @media only screen and (max-width: 768px) {
        display: block;
      }

      div {
        display: flex;
        flex-direction: column;
        gap: 4px;

        span {
          background: #7BC4E0;
          width: 25px;
          height: 2px;
          border-radius: 2px;
          transition: all 0.3s;

          &:nth-child(2) {
            width: 20px;
          }
        }
      }

      &:hover {
        div span {
          background: white;
          width: 25px;
        }
      }
    }

    .logo {
      max-width: 260px;
      img {
        width: auto;
        height: 55px;
        min-width: 100px;
        object-fit: contain;
        filter: brightness(1.1);

        &.sm {
          display: none;
        }

        @media only screen and (max-width: 768px) {
          height: 45px;

          &.sm {
            display: block;
          }
          &.xl {
            display: none;
          }
        }
      }
    }
  }

  .right {
    background: rgba(45, 95, 122, 0.3);
    box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.1);
    border-radius: 30px;
    align-items: center;
    align-self: center;
    gap: 10px;
    padding-left: 5px;
    padding-right: 20px;
    color: #fff;
    font-size: 15px;
    height: 50px;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.3s ease;
    border: 1px solid rgba(123, 196, 224, 0.2);

    &:hover {
      background: rgba(45, 95, 122, 0.5);
      border-color: #7BC4E0;
      box-shadow: 0 4px 12px rgba(123, 196, 224, 0.2);
    }

    .name {
      white-space: nowrap;
      color: #CCE6F5;

      @media only screen and (max-width: 768px) {
        display: none;
      }
    }

    .icon {
      width: 40px;
      height: 40px;
      border-radius: 50%;
      background-color: #2D5F7A;
      overflow: hidden;
      display: flex;
      align-items: center;
      justify-content: center;
      border: 2px solid #7BC4E0;

      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }

      .avatar-fallback {
        width: 100%;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        background: #1A2F3A;
        color: #7BC4E0;
        font-weight: bold;
        font-size: 18px;
      }
    }
  }

  @media only screen and (max-width: 768px) {
    padding: 10px 16px;

    .left {
      gap: 8px;
      .badgeIcon {
        margin-left: 0;

        div span {
          width: 22px;
        }
      }
    }

    .right {
      padding-right: 12px;
      height: 45px;

      .icon {
        width: 35px;
        height: 35px;
      }
    }
  }

  @media only screen and (max-width: 480px) {
    padding: 8px 12px;

    .left .logo img {
      height: 40px;
    }

    .right {
      padding-right: 8px;

      .icon {
        width: 32px;
        height: 32px;
      }
    }
  }
`;